import { DOT_SYMBOL } from '../../constants/constants';
export var getIsDisabledState = (disabledState, widgetInternalDisabledState) => {
  return disabledState || widgetInternalDisabledState;
};
export var getSubHeading = (incomeDropdownValue, familyIncomeDropdownValue, subHeading) => {
  if (subHeading) {
    return subHeading;
  }
  return incomeDropdownValue + " " + DOT_SYMBOL + " " + familyIncomeDropdownValue;
};